import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { arEG } from "@mui/material/locale";
import { theme } from "./Theme";

const rtlCache = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
const ltrCache = createCache({ key: "mui" });

export default function AppTheme({ children }) {
  const { i18n } = useTranslation();
  const arabic = i18n.resolvedLanguage === "ar";
  const appTheme = useMemo(
    () => (arabic ? createTheme(theme, { direction: "rtl" }, arEG) : theme),
    [arabic],
  );
  return (
    <CacheProvider value={arabic ? rtlCache : ltrCache}>
      <ThemeProvider theme={appTheme}>{children}</ThemeProvider>
    </CacheProvider>
  );
}
